let moment = require('moment')
let accounting = require('@/vendors/javascripts/accounting.min.js')
import Vue from 'vue'


accounting.settings = {
  currency: {
    symbol : "$",   // default currency symbol is '$'
    format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
    decimal : ",",  // decimal point separator
    thousand: " ",  // thousands separator
    precision : 2   // decimal places
  },
  number: {
    precision : 0,  // default precision on numbers is 0
    thousand: ",",
    decimal : "."
  }
}

Vue.filter('formatDate', function (value) {
  return moment.unix(value).format('YYYY-MM-DD')
})

Vue.filter('round', function (value) {
  return accounting.formatMoney(value, {symbol: ''})
})
Vue.filter('toCurrency', function (value) {
    return accounting.formatMoney(value)
})

Vue.filter('dateFormat', function (value, format = 'YYYY-MM-DD') {
  return moment.unix(value).format(format)
})

Vue.filter('s3Image', function (path) {
  return `${process.env.S3_IMAGES_END_POINT}/${path}`;
})

Vue.filter('toMinutes', function (minutes) {
  var sign = minutes < 0 ? "-" : "";
  var min = Math.floor(Math.abs(minutes));
  var sec = Math.floor((Math.abs(minutes) * 60) % 60);
  return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
})



// WEBPACK FOOTER //
// ./src/filters/index.js